import * as actions from './getUserSecurityQuestionsActions';

const getUserSecurityQuestionsReducers = {
  [actions.USER_GET_USER_SECURITY_QUESTIONS_SUCCESS_RECEIVED]: (
    state,
    { payload: { questions } }
  ) => {
    state.userSecurityQuestions = questions || [];
    return state;
  },
};

export default getUserSecurityQuestionsReducers;
